export const VaraEvent = {
  VaraRestrictionModalView: 'vara_restriction_modal_view',
  KycRestrictionModalView: 'kyc_restriction_modal_view',
} as const;

export interface VaraEventDataType {}
